import { createContext } from 'react';

export const IndexContext = createContext({
  baseUrl: '',
  isLogged: false
});
